import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { ErrorsTranslateService } from 'src/app/errors-translate.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public userForm = {
    email: '',
    password: '',
    linkedin: ''
  };

  public errorMsg = '';

  constructor(
    private auth: AuthService,
    private router: Router,
    private afs: AngularFirestore,
    private errorService: ErrorsTranslateService) {
      this.auth.getUser().then((user) => {
        if (user) {
          this.router.navigate(['/u', 'stream', 'main'])
        }
      })
    }

  ngOnInit(): void {
  }

  loginWithEmail() {
    if (this.userForm.linkedin.length < 5) {
      this.errorMsg = 'Please fill in your social media link for networking';
      return;
    } else {
      this.auth.emailSignIn(this.userForm.email, this.userForm.password).then((data) => {
        let uid = data.user.uid;
        this.afs.collection('users').doc(uid).update({
          linkedin: this.userForm.linkedin
        })
        this.router.navigate(['u', 'stream', 'main']);
      }).catch((err) => {
        this.errorMsg = err.message;
        console.error(err);
      })
    }
  }

  loginWithGoogle() {
    this.auth.googleSignIn().then(() => {
      this.router.navigate(['u', 'stream', 'main']);
    })
  }

  goToRestorePassword(e) {

  }

}
